export const getKey = (name: string, price: number) => `${name}__${price}`;
